import { render } from "./Luisa.vue?vue&type=template&id=56904dbc"
import script from "./Luisa.vue?vue&type=script&lang=js"
export * from "./Luisa.vue?vue&type=script&lang=js"

import "./Luisa.vue?vue&type=style&index=0&id=56904dbc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__